import { Button, Grid, Typography } from "@material-ui/core";
import { toolbarStyles } from "./toolbarStyles";

type DateButtonsProps = {
  onChangeCalendarType: (type: "year" | "date") => void;
  date: Date;
};

export const DateButtons = ({
  onChangeCalendarType,
  date,
}: DateButtonsProps) => {
    
  const classes = toolbarStyles();

  const formatDate = () => {
    const text = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "2-digit",
    }).format(date);
    return text[0] + text.slice(1).toLowerCase();
  };

  return (
    <Grid item xs={5}>
      <div>
        <Button
          variant="text"
          className={classes.buttonReset}
          onClick={() => onChangeCalendarType("year")}
        >
          <Typography variant="subtitle1">{date.getFullYear()}</Typography>
        </Button>
      </div>
      <div>
        <Button
          variant="text"
          className={classes.buttonReset}
          onClick={() => onChangeCalendarType("date")}
        >
          <Typography variant="h4">{formatDate()}</Typography>
        </Button>
      </div>
    </Grid>
  );
};
